<template>
  <div class="contact">
    <div class="hero">
      <div class="container">
        <h3>Voor al je vragen</h3>
        <h1>Neem contact met ons op</h1>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="sub-title">
              Een probleem met Roosterplatform?
            </div>
            <p>
              Mail naar
              <a
                href="mailto: support@roosterplatform.nl"
              >support@roosterplatform.nl</a>
              als u een probleem met Roosterplatform hebt. Wij maken dan
              automatisch een helpdesk ticket aan en helpen u zo snel mogelijk.
              In uw helpdesk klantportaal kunt u uw ticket volgen of een nieuwe
              aanmaken.
            </p>
            <div class="sub-title">
              Een vraag over uw factuur?
            </div>
            <p>
              Ga naar uw factuur klantportaal als u een vraag heeft over uw
              factuur.
            </p>
            <div class="sub-title">
              Een algemene vraag?
            </div>
            <p>
              We zijn op werkdagen bereikbaar op telefoonnummer
              <a
                href="tel:+31 (0) 85 808
              1120"
              >+31 (0) 85 808 1120</a>. En via mail op
              <a
                href="mailto: info@roosterplatform.nl"
              >info@roosterplatform.nl</a>
            </p>
            <div class="sub-title">
              Openingstijden
            </div>
            <p>Maandag - Vrijdag 09:00 – 18:00</p>
          </div>
          <div class="col-12 col-md-6">
            <iframe
              class="zoho-form"
              width="610px"
              height="350px"
              src="https://crm.zoho.com/crm/WebFormServeServlet?rid=61b8239ee9f29d0984a26a454f65afbcc15367c476a2df922f5e630b5adabf46gid326a4cd1ddea7cc4c1d6d3044679fca61a9a029aafed99a30972d287f6bb6add"
            />
          </div>
          <!-- <div class="col-12 col-md-5 offset-md-1">
            <div class="form-holder">
              <b-form-group>
                <b-form-input placeholder="Bedrijf/Instelling*" />
              </b-form-group>

              <b-form-group>
                <div class="row">
                  <div class="col-6">
                    <b-form-input
                      s
                      placeholder="Voornaam*"
                    />
                  </div>
                  <div class="col-6">
                    <b-form-input
                      s
                      placeholder="Achternaam*"
                    />
                  </div>
                </div>
              </b-form-group>
              <b-form-group>
                <div class="row">
                  <div class="col-6">
                    <b-form-input
                      s
                      placeholder="E-mail*"
                    />
                  </div>
                  <div class="col-6">
                    <b-form-input
                      s
                      placeholder="Telefoonnummer"
                    />
                  </div>
                </div>
              </b-form-group>
              <b-form-group>
                <b-form-textarea
                  placeholder="Typ uw vraag in"
                  rows="3"
                  max-rows="6"
                />
              </b-form-group>
              <b-button class="button primary-button send-button">
                Sturen
              </b-button>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="section primary extra-padding-bottom">
      <div class="container">
        <iframe
          class="map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2444.8483900356523!2d5.27981041611685!3d52.2098025797566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c64148f75529dd%3A0xeb10368d0bb28501!2sRoosterplatform!5e0!3m2!1snl!2snl!4v1614356627535!5m2!1snl!2snl"
          width="600"
          height="450"
          allowfullscreen=""
          loading="lazy"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Clients",

  mounted() {},
  methods: {},
  metaInfo() {
    return {
      title: "Roosterplatform - Klanten",
    };
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/colors.scss";
@import "../assets/css/variables.scss";

.hero {
  padding: 100px 0 200px;
  min-height: 600px;
  p {
    font-size: $big;
  }
  h3 {
    opacity: 0.3;
    font-weight: 700;
  }
}

.form-holder {
  background: $grey-light;
  padding: 20px;
  border-radius: $border-radius;
  .send-button {
    width: 100%;
  }
}

.map {
  width: 100%;
  border: 10px solid rgba($color: $white, $alpha: 0.5);
  border-radius: $border-radius;
  margin-top: -200px;
}
.zoho-form {
  background: $grey-light;
  margin-left: 40px;
  border-radius: $border-radius;
  width: 100%;
  height: 370px;
}
@media (max-width: 767px) {
  .hero {
    padding-top: $header-height-small;
  }
  .zoho-form {
    width: 100%;
    height: 600px;
    margin: 0;
  }
}
</style>
